export default __webpack_public_path__ + "static/media/Icon material-timer.386dc5b3.svg";